import { defineMessages } from "react-intl"

export default defineMessages({
  noAnswerTitle: {
    id: "app.components.SubFooter.noAnswerTitle"
  },
  noAnswerText: {
    id: "app.components.SubFooter.noAnswerText"
  },
  noAnswerTextWithFAQ: {
    id: "app.components.SubFooter.noAnswerTextWithFAQ"
  },
  sendUsMessageButton: {
    id: "app.components.SubFooter.sendUsMessageButton"
  },
  tellMeMore: {
    id: "app.components.Home.tellMeMore"
  }
})
